module.exports = require("cookie-parser");


//////////////////
// WEBPACK FOOTER
// external "cookie-parser"
// module id = 11
// module chunks = 0